import { Box, Button, CircularProgress, Divider, Typography } from "@material-ui/core";
import { styled } from '@material-ui/core/styles';
import React from "react";
import TextFieldInput from "../../../Shared/Forms/KendoFields/TextFieldInput";
import { memberIDField, groupIDField, rxBINField, pCNField, firstNameField, lastNameField, phoneNumber1Field, dateOfBirthField, addressLine1Field, cityField, stateField, postalcodeField, countryField, genderField, last4SSNField, statusField, tokenIdField } from "./helpers";
import NumberFieldInput from "../../../Shared/Forms/KendoFields/NumberFieldInput";
import DateInput from "../../../Shared/Forms/KendoFields/DateInput";
import ToggleInput from "../../../Shared/Forms/KendoFields/ToggleField";

const SubscriberForm = ({
  hasData,
  subscriber,
  onSubscriberChange,
  fvSubsLoading,
  onUpdate
}) => {

  const {
    token: { cardTokenID },
    status = null,
    healthCare: { memberID = "", groupID = "", rxBIN = "", pcn = "" },
    demographicInfo: {
      name: { firstName = "", lastName = "" },
      phone: { phoneNumber1 = "" },
      dateOfBirth = "",
      gender = "",
      last4SSN = 0,

      address: {
        addressLine1 = "",
        city = "",
        state = "",
        postalcode = "",
        country = ""
      }
    },
  } = subscriber

  /* CONVERT Birth Date to Date Object */
  const dobArrSubStr = dateOfBirth.split('');
  const MM = dobArrSubStr.splice(0,2).join('');
  const DD = dobArrSubStr.splice(0,2).join('');
  const YYYY = dobArrSubStr.splice(0,4).join('');
  const dobInputVal = new Date(`${MM}-${DD}-${YYYY}`);

  const handleTextInputChange = (e) => {
    onSubscriberChange(e.target.name, e.target.value)
  }

  const handleDateChange = (fieldName, fieldVal) => {
    onSubscriberChange(fieldName, fieldVal)
  }

  const handleToggleChange = (fieldName, fieldVal) => {
    onSubscriberChange(fieldName, fieldVal)
  }

  // console.log(memberID)
  // console.log(firstName)
  // console.log(lastName)
  // console.log(dateOfBirth)

  // fix: SAF-8760 set the status to Active if string is "Active".
  //  If "Inactive" then set it to false
  const isActive = status === 'Active' ? true : false;

  return (
    <Box>
      <Typography variant="h6">
        Primary Account
      </Typography>
      <Box display={'flex'} alignItems={'center'} marginTop={'10px'} marginBottom={'20px'}>
        <Box marginRight={'20px'}>
          <ToggleInput
            field={statusField}
            value={isActive}
            handleChangeWithParams={handleToggleChange}
          />
        </Box>
        <Box display={'inline-block'} >
          <Typography variant="subtitle2">
            Use the toggle to set the Subscriber Account to Active/Inactive
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box marginTop={'10px'} marginBottom={'8px'} style={{textDecoration: 'underline'}}>
        <Typography>
          Account Info
        </Typography>
      </Box>
      <FormWrapper>
        <HealthInfoC>
          <Box gridColumn={'1 / span 2'}>
            <TextFieldInput
              field={tokenIdField}
              value={cardTokenID}
              handleChange={handleTextInputChange}
            />
          </Box>
          <TextFieldInput
            field={memberIDField}
            value={memberID}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={groupIDField}
            value={groupID}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={rxBINField}
            value={rxBIN}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={pCNField}
            value={pcn}
            handleChange={handleTextInputChange}
          />
        </HealthInfoC>
        <BasicDetailsC>
          <Box gridColumn={'1 / span 2'} style={{textDecoration: 'underline'}}>
            <Typography>
              Personal Info
            </Typography>
            <Divider />
          </Box>
          <TextFieldInput
            field={firstNameField}
            value={firstName}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={lastNameField}
            value={lastName}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={genderField}
            value={gender}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={last4SSNField}
            value={last4SSN}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={phoneNumber1Field}
            value={phoneNumber1}
            handleChange={handleTextInputChange}
          />
          <DateInput
            field={dateOfBirthField}
            value={dobInputVal}
            handleChangeWithParams={handleDateChange}
          />
        </BasicDetailsC>
        <AddressInfoC>
          <Box gridColumn={'1 / span 2'} style={{textDecoration: 'underline'}}>
            <Typography>
              Address Info
            </Typography>
            <Divider />
          </Box>
          <TextFieldInput
            field={addressLine1Field}
            value={addressLine1}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={cityField}
            value={city}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={stateField}
            value={state}
            handleChange={handleTextInputChange}
          />
          <NumberFieldInput
            field={postalcodeField}
            value={postalcode}
            handleChange={handleTextInputChange}
          />
          <TextFieldInput
            field={countryField}
            value={country}
            handleChange={handleTextInputChange}
          />
        </AddressInfoC>
        <ActionC>
          <Button variant="contained" color="primary" onClick={onUpdate} disabled={fvSubsLoading === 'pending'}>
            <Box display={'flex'} alignItems={'center'}>
              <Box display={'inline-block'}>Update Primary</Box>
              {
                fvSubsLoading === 'pending' && <Box display={'inline-block'} marginLeft={'8px'}>
                  <CircularProgress size={20} color="primary"/>
                </Box>
              }
            </Box>
          </Button>
        </ActionC>
      </FormWrapper>
    </Box>
  )
};


const FormWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr',
  paddingBlock: '5px',
  rowGap: '20px',
})

const HealthInfoC = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  rowGap: '16px',
  columnGap: '100px',
  'container': 'health-info / inline-size',
  paddingLeft: '5px',
})

const BasicDetailsC = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  rowGap: '16px',
  columnGap: '100px',
  marginTop: '20px',
  'container': 'basic-info / inline-size',
  paddingLeft: '5px',
  alignItems: 'center',
})

const AddressInfoC = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  rowGap: '16px',
  columnGap: '100px',
  marginTop: '20px',
  'container': 'basic-info / inline-size',
  paddingLeft: '5px',
})

const ActionC = styled('div')({
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export default SubscriberForm;
